import { Stack } from "@mui/material";
import { StatTable } from "../components";
import { useScreenSize } from "../hooks";
import { statTableApi } from "../hooks";
import { StatTableInterface } from "../interfaces"; // Import the interface

export const StatTableContainer = () => {
  const { belowDesktop } = useScreenSize();
  const statTableData = statTableApi(); // Define the type of statTableData

  return (
    <Stack
      direction={belowDesktop ? "column" : "row"}
      margin={4}
      marginBottom={10}
      spacing={1}
      gap={1}
      padding={1}
      justifyContent="space-between"
    >
      {statTableData.map((item: StatTableInterface, key: number) => (
        <StatTable key={key} {...item} />
      ))}
    </Stack>
  );
};
